import React, { Component } from "react";
/*import StatusIcon from "../component/StatusIcon";*/

export default class StatusSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: ""
    };
  }

  componentDidMount() {}

  getTitle() {
    if (this.props.recommended) {
      return "Empfoglen";
    } else {
      return " ";
    }
  }

  render() {
    var style = {
      backgroundColor: "#0000",
      width: "70px",
      height: "auto",
      padding: 5,
      alignItems: "center",
      justifyContent: "center",
      color: "white",
      border: "1px solid #fff",
      cursor: "pointer",
      borderRadius: 1
    };

    if (this.props.fat) style.width = "150px";

    if (this.props.recommended) {
      style.backgroundColor = "#FFF";
      style.borderWidth = "0px";
      style.color = "black";
    }

    if (this.props.disabled) {
      style.border = "1px solid grey";
      style.color = "grey";
    }

    return (
      <div
        style={{
          width: "auto",
          height: "auto",
          display: "flex",
          flexDirection: "column"
        }}
      >
        <div
          style={style}
          onClick={() => {
            this.props.action();
          }}
        >
          <p style={{ textAlign: "center", fontSize: "12px" }}>
            {this.props.text}
          </p>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/ActionButton.js